import { Component } from '@angular/core';

import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent   {


  constructor(private modalCtrl: ModalController) {}

  cancel() {
    return this.modalCtrl.dismiss('', 'cancel');
  }

  confirm() {
    return this.modalCtrl.dismiss('', 'confirm');
  }

}
